import Environment from '@di-shared/features/environment/Environment';
import Eu from '@di-shared/features/history/download/HistoryDownloadForm/.eu';
import Kr from '@di-shared/features/history/download/HistoryDownloadForm/.kr';

export interface HistoryDownloadFormProps {
  vin: string;
}

export default function HistoryDownloadForm({vin}: HistoryDownloadFormProps) {
  return (
    <>
      <Environment.Eu>
        <Eu vin={vin} />
      </Environment.Eu>
      <Environment.Kr>
        <Kr vin={vin} />
      </Environment.Kr>
    </>
  );
}
